import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ReportExportService } from "../../api/services";
import { PowerbiReportEmbedComponent } from "../../elements/powerbi-report-embed/powerbi-report-embed.component";
import { GlobalApp } from "../../tools/global";

@Component({
  selector: "print-report-component",
  templateUrl: "./print-report.component.html"
})
export class PrintReportComponent implements AfterViewInit {

  @ViewChild(PowerbiReportEmbedComponent) powerBi: PowerbiReportEmbedComponent;
  public showReport: boolean = false;
  public isInvalid: boolean = false;
  public isExpired: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private app: GlobalApp,
    private reportExportService: ReportExportService
  ) {
    app.setFullScreenMode();
  }

  ngAfterViewInit() {
    this.route.paramMap.subscribe((params) => {
      var reportExportId: number = parseInt(params.get('reportExportId'));
      this.reportExportService.reportExportGetStandardReportDetails(reportExportId).subscribe((result) => {
        if (!result.valid) {
          this.isInvalid = true;
        } else if (!result.subscriptionValid) {
          this.isExpired = true;
        } else {
          this.powerBi.loadReportState(false, result.reportStandardLayout, [], result.reportSource, result.reportStandardType, null);
          this.showReport = true;
        }
      });      
    })
  }
}
